module.exports = __webpack_public_path__ + "static/media/feedback.27e638cc.svg";